import { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import Header from './Header';
import Sidebar from './Sidebar';
import { setActiveRole, setUser, useUserSlice } from '#/store/slices/user/userSlice';
import { useRouteInfo } from './routeInfo';
import { useDispatch } from 'react-redux';
import { Role } from '#/store/slices/api/types/user';

export function AppLayout() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { activeRole } = useUserSlice();
  const [drawerOpen, setDrawerOpen] = useState(true);

  const { userTypes } = useRouteInfo();

  useEffect(() => {
    if (!userTypes.includes(activeRole)) {
      navigate('/');
    }
  }, [userTypes, activeRole, navigate]);

  useEffect(() => {
    const jwt = localStorage.getItem('jwt');
    const user = localStorage.getItem('user');
    const activeRole = localStorage.getItem('activeRole');

    if (!jwt || !user) {
      localStorage.clear();
      navigate('/login');
      return;
    }

    dispatch(setUser(JSON.parse(user)));
    dispatch(setActiveRole(activeRole as Role ?? Role.INSTRUCTOR));
  }, [dispatch, navigate]);

  return (
    <Box className="app-container">
      <Header drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
      <Box display="flex" sx={{ flex: 1, mt: '62px' }}>
        <Sidebar drawerOpen={drawerOpen} />
        <Box
          component="main"
          className="main-content"
          sx={{
            flexGrow: 1,
            marginLeft: drawerOpen ? 0 : '-240px',
            transition: (theme) => theme.transitions.create('margin', {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen,
            }),
            height: 'calc(100vh - 60px)',
            overflow: 'auto',
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}